module.exports = __webpack_public_path__ + "media/images/icons/SVG/002-1e722e74cacd58f707ea651ee9673ac8.svg";